import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const LI = styled.li`
  list-style-type: none;
  font-weight: normal;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: underline;
  color: var(--clr-grey-0-to-grey-3);
`

const GuideLink = ({ text, guide, next, query}) => {
  return (
    <LI>
      <Link
        onClick={() => next(guide)}
        to={{ pathname: `/guides/${guide.slug}`, query}}
        className="guides-link"
        role="listitem"
      >
        {text}
      </Link>
      <br />
    </LI>
  )
}

GuideLink.propTypes = {
  text: PropTypes.string.isRequired,
  guide: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
}

export default GuideLink



// WEBPACK FOOTER //
// ./src/components/GuideLink/GuideLink.js